import { Grid } from "@mui/material";
import { observer } from "mobx-react";
import React from "react";
import WorkflowsNavigation from "./Views/WorkflowsNavigation";
import WorkflowsRoutes from "./Views/WorkflowsRoutes";


type Props = {};

const Workflows: React.FC<Props> = observer(() => {
    return (
        <Grid container sx={{ padding: "2rem", height: "calc(100% - 20px)" }}>
            <WorkflowsRoutes />
            <WorkflowsNavigation />
        </Grid>
    );
});

export default Workflows;
